import ClImageWrapp from '../UI/ClImageWrapp/ClImageWrapp';
import './ClAppButton.css';

const ClAppButton = function (id, events, {
    lbl, icon,
    styleType = 'prim', // prim, sec or ter
    btnType = 'button', // button or link
    customStyleSttgs,
    stack = 'h', // v or h
    align = 'center' // center, left or right
}) {

    const palette = {
        'prim': { bg: '#1868c3', color: '#fff', outline: false },
        'sec': { bg: '#747474', color: '#fff', },
        'ter': { bg: '#00ADEE', color: '#fff' },
    }

    let props = {
        id: id,
        name: lbl,
        type: btnType,
        events: events || [],
        icon: icon,
        styleType: (pStyleType = styleType) => {
            let cssVarsObj = palette['prim'];
            if (pStyleType.includes('custom')) {
                cssVarsObj = customStyleSttgs;
            } else {
                const kFound = Object.keys(palette).find(sType => sType.toLowerCase().includes(pStyleType.split('-')[0].toLowerCase()));
                cssVarsObj = kFound ? palette[kFound] : palette['prim'];
                if (btnType === 'button' && pStyleType.includes('outline')) cssVarsObj.outline = true;
            }
            // console.log(cssVarsObj);
            return cssVarsObj;
        },
        ele: null,
    }
    let baseEle = props.type === 'a' ? 'a' : 'button';


    const setIcon = (baseEle, value, side = 'left') => {
        let i = ClImageWrapp({
            mediaType: 'svg',
            url: value,
            wrappType: 'i'
        });
        i.build()
            .then(imgEle => {
                // console.log('setIcon ==== >>>   ', imgEle);
                if (side === 'right') baseEle.appendChild(imgEle);
                else {
                    if (baseEle.firstElementChild) baseEle.insertBefore(imgEle, baseEle.firstElementChild);
                    else baseEle.appendChild(imgEle);
                }
            });
    }

    const setText = (baseEle, text) => {
        const textEle = document.createElement('span');
        textEle.textContent = text;
        textEle.classList.add('cl-app-btn__text');
        baseEle.appendChild(textEle);
    }

    const setAlignment = (pStack) => {
        const baseClass = 'cl-app-btn';
        const txtAlign = {
            center: 'center',
            left: 'left',
            right: 'right'
        }
        if (pStack === 'v') baseEle.classList.add(`${baseClass}--vertical`);
        baseEle.classList.add(`${baseClass}--${txtAlign[align] || txtAlign.center}`)
    }

    const createElement = () => {
        baseEle = document.createElement(baseEle);
        const { bg, color, outline = false } = props.styleType(styleType);
        baseEle.classList.add('cl-app-btn');
        if (outline) baseEle.classList.add('cl-app-btn--outline');
        if (props.type === 'button') {
            if (styleType.includes('-sm')) baseEle.classList.add('cl-app-btn-sm');
            if (styleType.includes('-lg')) baseEle.classList.add('cl-app-btn-lg');
        }
        baseEle.style = `--cl-plg-btn-bg: ${bg}; --cl-plg-btn-tx: ${color}; --cl-plg-clr-l: 35%;`;
        baseEle.id = props.id;
        baseEle.setAttribute('tabindex', '0');
        if (props.name) setText(baseEle, props.name);
        events.forEach(({ type, cb }) => {
            if (!baseEle['on' + type])
                baseEle['on' + type] = (e) => {
                    e.preventDefault();
                    cb(e);
                };
        });
        // adds an icon if present
        // console.log('ESTAAAAA', props?.icon?.value);
        if (props?.icon?.value) setIcon(baseEle, props.icon.value, props.icon.pos);
        setAlignment(stack);
        props.ele = baseEle;
        return baseEle;
    }
    const build = () => {
        return createElement();
    }

    // const setDarkMode = function(enable = false) {
    // }

    return { build }
}

export default ClAppButton;
